import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import SvgClose from '@/assets/icons/close.svg';
import SvgReset from '@/assets/icons/reload.svg';
import SvgCreate from '@/assets/icons/magic-wand-light.svg';
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";

interface Props {
    title?: string;
    cancelText?: string;
    approveText?: string;
    maxWidth?: number;
    isLoading?: boolean;
    isDisableApprove?: boolean;
    actionsPosition?: 'left' | 'right' | 'center';
    titlePosition?: 'center' | 'left';
    isFullScreen?: boolean;
    isHideCancelButton?: boolean;
    isHideActions?: boolean;
    isSmallTitle?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: { default: '' },
    cancelText: { default: 'Отменить' },
    approveText: { default: 'Создать' },
    maxWidth: { default: 400 },
    isLoading: { type: Boolean },
    isDisableApprove: { type: Boolean },
    actionsPosition: { default: 'right' },
    titlePosition: { default: 'left' },
    isFullScreen: { type: Boolean },
    isHideCancelButton: { type: Boolean },
    isHideActions: { type: Boolean },
    isSmallTitle: { type: Boolean }
  },
  emits: ['close', 'cancel', 'approve'],
  setup(__props: any, { emit: emits }) {

const props = __props as { title: string, cancelText: string, approveText: string, maxWidth: number, isLoading?: boolean, isDisableApprove?: boolean, actionsPosition: 'left' | 'right' | 'center', titlePosition: 'center' | 'left', isFullScreen?: boolean, isHideCancelButton?: boolean, isHideActions?: boolean, isSmallTitle?: boolean }




const modalContainerRef = ref<HTMLElement | null>(null);

const outsideClose = (event: MouseEvent) => {
    if (modalContainerRef.value?.contains(event.target as Node)) {
        emits('close');
    }
};

return { __sfc: true,props, emits, modalContainerRef, outsideClose, SvgClose, SvgReset, SvgCreate, BaseButtonV2 }
}

})